
import React from 'react';
import moment from 'moment';
import { ChildProps } from 'react-apollo';
import I18n from 'i18n-js';

import { withGraphql } from '@reverbdotcom/commons/src/with_graphql';
import { PRICE_GUIDE_TOOL_CONDITIONS } from '@reverbdotcom/commons/src/condition_helpers';

import { SellFormPricingModal, PAGE_SIZE } from './SellFormPricingModal';
import { transactionsTableQuery } from '../../../../price_guide_tool/csp_module/shared/csp_transaction_table_container';
import {
  SELLER_COUNTRY_CODES,
  PAID_TRANSACTION_STATUSES,
} from '../../../../price_guide_tool/show/price_guide_tool_transaction_graph_container';

import {
  SearchPriceGuideToolTransactionTable,
} from '../../../../../schemas/rql';

const DEFAULT_OFFSET = 0;
const CREATED_AFTER_FILTER = moment().subtract(1, 'years').startOf('day').format();
interface IQueryVariableArgs {
  canonicalProductIds: string[];
  offset?: number;
}

export function queryVariables({
  canonicalProductIds,
  offset = DEFAULT_OFFSET,
}: IQueryVariableArgs) {
  return {
    canonicalProductIds,
    conditionSlugs: PRICE_GUIDE_TOOL_CONDITIONS,
    sellerCountries: SELLER_COUNTRY_CODES,
    actionableStatuses: PAID_TRANSACTION_STATUSES,
    createdAfterDate: CREATED_AFTER_FILTER,
    limit: PAGE_SIZE,
    offset,
  };
}

interface IExternalProps {
  canonicalProductIds: string[];
}

type IProps = ChildProps<IExternalProps, SearchPriceGuideToolTransactionTable.Query>;

export function SellFormTransactionsModalContainer({
  canonicalProductIds = [],
  data,
}: IProps) {
  const { priceRecordsSearch = {} } = data ?? {};
  const {
    priceRecords = [],
    total = 0,
    offset = 0,
  } = priceRecordsSearch;

  if (!total) { return null; }

  const filteredPriceRecords = priceRecords
    .filter(priceRecord => !!priceRecord.createdAt)
    .map(priceRecord => ({
      timestamp: priceRecord.createdAt,
      conditionDisplayName: priceRecord.condition.displayName,
      priceDisplay: priceRecord.amountProduct.display,
      id: priceRecord._id,
    }));

  return (
    <div className="mr-10 tablet-mr-0 tablet-mb-1">
      <SellFormPricingModal
        buttonText={I18n.t('discovery.sellForm.pricingSection.pricingTables.recentlySoldListings.buttonText')}
        headerTitle={I18n.t('discovery.sellForm.pricingSection.pricingTables.recentlySoldListings.modalHeader')}
        dateHeader={I18n.t('discovery.sellForm.pricingSection.pricingTables.recentlySoldListings.dateHeader')}
        priceRecords={filteredPriceRecords}
        offset={offset}
        total={total}
        refetch={(newOffset) => {
          data.refetch({
            canonicalProductIds,
            offset: newOffset,
          });
        }}
      />
    </div>
  );
}

const withTransactionsTableQuery = withGraphql<IProps, SearchPriceGuideToolTransactionTable.Query>(
  transactionsTableQuery,
  {
    skip: ({ canonicalProductIds }) => !canonicalProductIds?.length,
    options: ({
      canonicalProductIds,
    }) => {
      return {
        ssr: false,
        errorPolicy: 'ignore',
        variables: queryVariables({
          canonicalProductIds,
        }),
      };
    },
  },
);

export default withTransactionsTableQuery(props => <SellFormTransactionsModalContainer {...props} />);
